import filter from 'lodash/filter';
import * as actions from './actions';
import { searchByText } from '../../helpers/utils';
import { DROPDOWN_DEFAULT_COUNTRY, DROPDOWN_DEFAULT_COURSE_ID } from '../../constants';

const initialState = {
    countries: [],
    subjects: [],
    filteredCourses: [],
    selectedCountry: DROPDOWN_DEFAULT_COUNTRY,
    masterCourses: [],
    selectedProductId: null,
    searchFilter: { searchTerm: '', yearGroup: undefined, subjectId: DROPDOWN_DEFAULT_COURSE_ID }
};

function filterCourses(masterCourses, searchFilter) {
    let results = searchByText(masterCourses, searchFilter.searchTerm);
    if (searchFilter.yearGroup) {
        results = filter(results, item => item.yearGroupList.indexOf(parseInt(searchFilter.yearGroup, 10)) !== -1);
    }

    if (searchFilter.subjectId !== '0') {
        results = filter(results, course => course.subjectId === parseInt(searchFilter.subjectId, 10));
    }

    return results;
}

export default function (state = initialState, action) {
    switch (action.type) {
    case actions.GET_SUBJECTS_REQUEST: {
        return {
            ...state,
            subjects: {
                items: [],
                isLoaded: true,
                isLoading: false
            }
        };
    }
    case actions.GET_SUBJECTS_SUCCESS: {
        return {
            ...state,
            subjects: {
                items: action.subjects,
                isLoaded: true,
                isLoading: false
            }
        };
    }
    case actions.GET_SUBJECTS_FAILURE: {
        return {
            ...state,
            subjects: {
                items: [],
                isLoaded: false,
                isLoading: false
            }
        };
    }
    case actions.GET_MASTER_COURSES_COUNTRIES_REQUEST: {
        return {
            ...state,
            countries: {
                items: [],
                isLoaded: false,
                isLoading: true
            }
        };
    }
    case actions.GET_MASTER_COURSES_COUNTRIES_SUCCESS: {
        return {
            ...state,
            countries: {
                items: action.countries,
                isLoaded: true,
                isLoading: false
            }
        };
    }
    case actions.GET_MASTER_COURSES_COUNTRIES_FAILURE: {
        return {
            ...state,
            countries: {
                items: [],
                isLoaded: false,
                isLoading: false
            }
        };
    }
    case actions.GET_MASTER_COURSES_BY_COUNTRY_REQUEST: {
        return {
            ...state,
            selectedCountry: action.countryCode,
            masterCourses: [],
            isLoaded: false,
            isLoading: true
        };
    }
    case actions.GET_MASTER_COURSES_BY_COUNTRY_SUCCESS: {
        const filteredCourses = filterCourses(action.masterCourses, state.searchFilter);
        return {
            ...state,
            masterCourses: action.masterCourses,
            filteredCourses,
            isLoaded: true,
            isLoading: false
        };
    }
    case actions.GET_MASTER_COURSES_BY_COUNTRY_FAILURE: {
        return {
            ...state,
            isLoaded: false,
            isLoading: false
        };
    }
    case actions.CHANGE_SUBJECT: {
        return {
            ...state,
            selectedProductId: action.productId
        };
    }
    case actions.CHANGE_COUNTRY: {
        return {
            ...state,
            selectedCountry: action.countryCode
        };
    }
    case actions.FILTER_MASTER_COURSES: {
        const filteredCourses = filterCourses(state.masterCourses, action.searchFilter);
        return {
            ...state,
            searchFilter: action.searchFilter,
            filteredCourses
        };
    }
    case actions.GET_MASTER_COURSES_REQUEST: {
        return {
            ...state,
            masterCourses: [],
            isLoading: true
        };
    }
    case actions.RESET_MASTER_COURSES: {
        return {
            ...state,
            masterCourses: []
        };
    }
    case actions.GET_MASTER_COURSES_SUCCESS: {
        const filteredCourses = filterCourses(action.masterCourses, state.searchFilter);
        return {
            ...state,
            masterCourses: action.masterCourses,
            filteredCourses,
            isLoaded: true,
            isLoading: false
        };
    }

    default:
        return { ...state };
    }
}




// WEBPACK FOOTER //
// ./app/containers/master-courses/reducer.js